import { render, staticRenderFns } from "./part_0.vue?vue&type=template&id=8cb10ba8&scoped=true&"
import script from "./part_0.vue?vue&type=script&lang=js&"
export * from "./part_0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb10ba8",
  null
  
)

export default component.exports